import { render, staticRenderFns } from "./DisplayEmpty.vue?vue&type=template&id=61e6a808&"
import script from "./DisplayEmpty.vue?vue&type=script&lang=js&"
export * from "./DisplayEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports